import Button from "../../../../components/Button/Button"
import EllipsisMenu from "../../../../components/EllipsisMenu/EllipsisMenu"
import FormDropdown from "../../../../components/FormDropdown/FormDropdown"
import FormInput from "../../../../components/FormInput/FormInput"
import { MAX_SCOPE_WORKFLOW_SECTIONS, MAX_SECTION_ANGLES } from "../../../../utils/constants"
import { AddSectionFormProps } from "./AddSectionForm.types"
import "./SectionForm.css"

const SectionForm = (props: AddSectionFormProps) => {

  const {
    sectionTypes,
    sectionStarts,
    onChangeSectionStarts,
    sectionEnds,
    onChangeSectionEnds,
    onSelectSection,
    sectionAngles,
    newAngle,
    onAddAngle,
    onRemoveAngle,
    currentSection,
    onAddSection,
    onRemoveCurrentSection,
    sectionAnglesEllipsisMenu,
    sectionAnglesEllipsisMenuState
  } = props

  const removeSection = (e: React.MouseEvent<HTMLDivElement>, index: number) => {
    e.stopPropagation()
    onRemoveCurrentSection()
  }

  return (
    <div className="section-form-container">
      <div className="pipe-section-container">
        <div className="pipe-container">
          <div className="pipe-end pipe-end-left"></div>
          <div className="pipe-body">
            {sectionStarts.map((_, key) => (
              <div
                key={key+1}
                className={`pipe-section ${currentSection === key ? "pipe-section-selected": ""}`}
                onClick={() => onSelectSection(key)}
              >
                <div className="pipe-section-delete" onClick={(e) => removeSection(e, key)}>
                  <p>-</p>
                </div>
                <p>Section {key+1}</p>
              </div>
            ))}

            {sectionStarts.length < MAX_SCOPE_WORKFLOW_SECTIONS && (
              <div className="add-pipe-section" onClick={onAddSection}>
                <p>Add Section</p>
              </div>
            )}

          </div>
          <div className="pipe-end pipe-end-right"></div>
        </div>
      </div>
      
      <div className="section-info-flex-container">
        <div className="current-section-container">
          <h3>Section information</h3>
          <div className="current-section-info">
            <FormInput
              label="Start"
              input={{
                value: sectionStarts[currentSection]?.value ?? "",
                onChange: (value: string) => onChangeSectionStarts(value, null),
                error: sectionStarts[currentSection]?.error ?? null
              }}
            />

            <FormInput
              label="End"
              input={{
                value: sectionEnds[currentSection]?.value ?? "0",
                onChange: (value: string) => onChangeSectionEnds(value, null),
                error: sectionEnds[currentSection]?.error ?? null
              }}
            />

            <FormDropdown
              label="Section Type"
              className="pipe-id-input"
              dropdown={sectionTypes}
            />

            <div className={`add-angle-input-container ${newAngle.error === null ? "" : "add-angle-input-container-error"}`}>
              <FormInput
                className="add-angle-button"
                label="Angle"
                input={newAngle}
                
              />
              <div
                className={`${sectionAngles[currentSection].length > MAX_SECTION_ANGLES ? "disable-add-angles" : ""}`}
              >
                <Button
                  title="Add"
                  type="full"
                  onClick={sectionAngles[currentSection].length < MAX_SECTION_ANGLES ? () => onAddAngle() : () => {}}
                />
              </div>
            </div>
          </div>

        </div>
        
        <div className="angles-container">
          <div className="section-container-header">
            <h3>Section angles</h3>
            <EllipsisMenu
              ellipsisMenu={
                {
                  items: sectionAnglesEllipsisMenu,
                  showMenu: sectionAnglesEllipsisMenuState.value,
                  onClick: () => sectionAnglesEllipsisMenuState.onChange(true),
                  onHide: () => sectionAnglesEllipsisMenuState.onChange(false),
                }
              }
            />

          </div>
          <div className="section-angles">
            {sectionAngles[currentSection] !== undefined && (
              <>
                {sectionAngles[currentSection].map((angle, key) => (
                  <div key={key} className="section-angle-row">
                    <p>{`${key+1}: ${angle.value}°`}</p>
                    <p
                      className={`remove-angle-button ${sectionAngles[currentSection].length === 1 ? "disabled" : ""}`}
                      onClick={() => onRemoveAngle(key)}
                    >
                      Remove
                    </p>
                  </div>
                ))}

                {sectionAngles[currentSection].length === 0 && (
                  <div className="no-results-container">
                  <p>No section angles.</p>
                </div>
                )}
              </>
            )}
            
          </div>
        </div>
      </div>
    </div>
  )
}

export default SectionForm